<template>
  <v-container :fluid="true" class="page_container pt-0">
    <div class="partner__title">
      <span class="partner__title--text">
        Партнеры
      </span>
      <span
          v-if="$vuetify.display.width > 960"
          class="partner__title--link"
          @click="navigateTo()"
      >
        Посмотреть всех
        <v-icon size="12" class="ml-5">$custom_arrow_sm</v-icon>
      </span>
    </div>
    <div class="partner__content">
      <PartnerCard
        v-if="!isLoading && partners.length > 0"
        :partners="partners"
        :justify_row="'space-around'"
      />
      <div v-else-if="!isLoading && partners.length === 0">
        <NoData/>
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div
          v-if="$vuetify.display.width <= 960"
          class="partner__more"
          @click="navigateTo()"
      >
        посмотреть все
      </div>
    </div>
  </v-container>

</template>

<script>
import { defineComponent } from 'vue'
import PartnerCard from "@/modules/templates/PartnerCard.vue"
import pa_names from "@/modules/personal_account/routers/names"
import { FulfillingSquareSpinner } from "epic-spinners"
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "UserPartners",
  components: { NoData, PartnerCard, FulfillingSquareSpinner },
  data () {
    return {
      cover: true,
      isLoading: true,
      partners: []
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      items: 'personal_account/partners/getLazyPartners',
      isLoadingPartners: 'personal_account/partners/isLazyLoadingPartners',
    }),
  },
  methods: {
    ...mapActions({
      loadLazyPartners: 'personal_account/partners/loadLazyPartners',
    }),
    navigateTo () {
      if (window.scrollY !== 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.$router.push({ name: pa_names.PARTNER.PAGE })
    },
    addCover (items) {
      for (let i = 0; i < items.length; i++) {
        this.partners.push({ ...items[i], cover: true })
      }
      this.isLoading = false
    },
    loadData (url = undefined) {
      this.loadLazyPartners({
        url: url,
        finalizer: (data) => {
          this.addCover(data)
        },
        catcher: () => {}
      })
    },
  },
  created () {
    this.loadData()
  }
})
</script>

<style scoped lang="scss">
.partner__title {
  display: flex;
  justify-content: space-between;
}

.partner__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.partner__title--link {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  height: 30px;
  font-size: 14px;
  line-height: 17px;
  color: #3254B9;
  cursor: pointer;
}

.partner__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 25px;
}

.partner__more {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 152px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

@media screen and (max-width: 960px) {
  .partner__content {
    position: relative;
  }
}

@media screen and (max-width: 768px) {
  .partner__content {
    padding: 0 25px 30px;
  }

  .partner__title {
    margin-top: 20px;
  }

  .partner__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .partner__title--link {
    align-items: start;
    font-size: 12px;
    line-height: 14px;
  }
}

@media screen and (max-width: 600px) {
  .partner__content {
    padding: 0;
  }
}
</style>
